import React, {useContext, useEffect, useRef, useState} from 'react';
import {useParams} from "react-router";
import Select from "react-select";
import axios from "axios";
import {baseURL} from "../../services/api";
import $ from "jquery";
import OrgContext from "../../organisation/OrgContext";
import AuthContext from "../../components/shared/AuthContext";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";
import {toast, ToastContainer} from "react-toastify";
import moment from "moment/moment";
import Swal from "sweetalert2";
import {formatNumber, isNumeric} from "../../helpers/formater";

const DevisDetails = (props) => {
    const {id} = useParams();

    const [client, setClient] = useState([]);
    const [invoiceCreatedAt, setInvoiceCreatedAt] = useState('');
    const [invoiceDueDate, setInvoiceDueDate] = useState('');
    const {organisation, changeOrg} = useContext(OrgContext);
    const {user, logout} = useContext(AuthContext);
    const [clients, setClients] = useState([]);
    const [clientToEditId, setClientToEditId] = useState(0);
    const [invoice, setInvoice] = useState([]);
    const [objet, setObjet] = useState('');
    const [invoiceNumber, setInvoiceNumber] = useState('');
    const [autoIncrementInvoiceNumber, setAutoIncrementInvoiceNumber] = useState(false);
    const [invoiceProductsState, setInvoiceProductsState] = useState([]);
    const [productIdToEdit, setProductIdToEdit] = useState(0);
    const [invoiceProducts, setInvoiceProducts] = useState([]);
    const [products, setProducts] = useState([]);
    const [qty, setQty] = useState(0);
    const [singleSelectedProduct, setSingleSelectedProduct] = useState([]);
    const [unitPrice, setUnitPrice] = useState(0);
    const [selectedProductQty, setSelectedProductQty] = useState(0);
    const [tva, setTva] = useState(0);
    const [totalHt, setTotalHt] = useState(0);
    const [selectedProduct, setSelectedProduct] = useState([]);

    //invoice status history
    const [invoiceStatusHistory, setInvoiceStatusHistory] = useState([]);
    const [invoiceStatus, setInvoiceStatus] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('');
    const [paymentType, setPaymentType] = useState('');
    const [banqueAccounts, setBanqueAccounts] = useState([]);
    const [bqAccountId, setBqAccountId] = useState(0);
    const [banquePaymentOption, setBanquePaymentOption] = useState('');
    const [chequeId, setChequeId] = useState('');
    const [payedAmount, setPayedAmount] = useState(0);
    const [invoiceProductsToDelete, setInvoiceProductsToDelete] = useState([]);
    const [reloadState, setReloadState] = useState(0);

    const leTotalHt = useRef(0);
    const leTotalTTc = useRef(0);

    //summary
    const [summaryTotatlHt, setSummaryTotatlHt] = useState(0);
    const [summaryTotalTva, setSummaryTotalTva] = useState(0);
    const [summaryTotatlTtc, setSummaryTotatlTtc] = useState(0);
    const [invoiceId, setInvoiceId] = useState('');

    //loaders
    const [loaderHistory, setLoaderHistory] = useState(0);
    const [invoiceDataLoader, setInvoiceDataLoader] = useState(0);
    const [invoiceClientLoader, setInvoiceClientLoader] = useState(0);
    const [invoiceProductsLoader, setInvoiceProductsLoader] = useState(0);

    useEffect(() => {
        calcInvoiceSummary()
    }, [invoiceProductsState])
    const calcInvoiceSummary = () => {
        let totalHt = 0;
        let totalTva = 0;
        let totalTtc = 0;

        for (let i = 0; i < invoiceProductsState.length; i++) {
            totalHt += parseFloat(invoiceProductsState[i].total_ht);
            totalTtc += parseFloat(invoiceProductsState[i].total_ttc);
            totalTva += (parseFloat(invoiceProductsState[i].total_ttc) - parseFloat(invoiceProductsState[i].total_ht));
        }
        setSummaryTotatlHt(totalHt);
        setSummaryTotalTva(totalTva);
        setSummaryTotatlTtc(totalTtc);
    }
    const editSingleInvoiceProduct = () => {
        if (qty == 0) {
            const errorMessage = 'Veuillez remplir la quantité du produit choisie !';
            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } else {
            for (let i = 0; i < invoiceProductsState.length; i++) {
                if (invoiceProductsState[i].product_id === productIdToEdit) {
                    invoiceProductsState[i].qty = qty;
                    invoiceProductsState[i].total_ht = leTotalHt.current.value;
                    invoiceProductsState[i].total_ttc = leTotalTTc.current.value;
                }
                setInvoiceProductsState([...invoiceProductsState]);
            }
        }
    }
    const getProductData = async (selectedProduct) => {
        const response = await axios.get(baseURL + `/product/get/${selectedProduct.value}`)
            .then((response) => {
                setQty(0)
                setUnitPrice(response.data.data[0]['sellingPrice'])
                setTva(response.data.data[0]['taxe_vente'].rate);
            })
            .catch((error) => console.log("error " + error))
    }

    const handleAutoIncrementInvoiceNumber = () => {
        if (autoIncrementInvoiceNumber === false) {
            $('#invoiceNumberInput').css('display', 'none');
        } else {
            $('#invoiceNumberInput').css('display', 'block');
        }
    }

    useEffect(() => {
        $(".all-fields-are-required-to-save").css('display', 'none');
        $("#warning-create-client-first").css('display', 'none');
        $("#table-rows").css('display', 'none');
        $("#all-fields-are-required").css('display', 'none');
        $("#warning-product-already-exists").css('display', 'none');
        $("#qty-is-higher").css('display', 'none');

        // getInvoiceStatusHistory();
        getFaData();
        getInvoiceProducts();
    }, []);

    const transformProductsArray = (products) => {
        let array = [];
        for (let i = 0; i < products.length; i++) {
            let obj = {value: products[i].id, label: products[i].name};
            array.push(obj);
        }
        return array;
    }

    const getInvoiceProducts = async () => {
        const response = await jwtInterceoptor.get(baseURL + `/data/user/devis_products/${id}`)
            .then((response) => {
                if (response.data.data.length === 0) {
                } else {
                    console.log("data : ", response.data.data)
                    setInvoiceProductsState(response.data.data);
                    console.log("setInvoiceProductsState: ", response.data.data)
                }
            }).catch((error) => console.log("error " + error))
    }
    const getSelectedInvoiceClientId = async () => {
        const response = await jwtInterceoptor.get(baseURL + `/data/user/factures/byid/${id}`)
            .then((response) => {
                if (response.data.data.length === 0) {
                } else {
                    setInvoice(response.data.data);
                    setClientToEditId(response.data.data.client_id);
                    setData(response.data.data);
                    console.log("cliets:", clients)
                }
            }).catch((error) => console.log("error " + error))
    }
    const setData = (invoice) => {
        setInvoiceDueDate(invoice.due_date);
        setInvoiceCreatedAt(moment(invoice.created_at).format("MM/DD/YYYY"));
        setObjet(invoice.title);
        setInvoiceNumber(invoice.devis_number);
        setInvoiceId(`Devis-${formatNumber(invoice.id)}`);
        setClient({
            value: invoice['client']['name'] + ' ' + invoice['client']['lastName'],
            label: invoice['client']['companyName']
        });
        setSummaryTotatlTtc(invoice.total_ttc);
        setSummaryTotalTva(invoice.total_tva);
        setSummaryTotatlHt(invoice.total_ht);
        setInvoiceStatus(invoice['status_infos']['name']);
    }
    const editSingleProduct = (productId) => {
        $('.select-article').css('display', 'none');
        $('.add-new-product-to-invoice-btn').css('display', 'none');
        $('.edit-single-product').css('display', 'revert');
        setProductIdToEdit(productId);
        let selectedProduct = [];
        selectedProduct = invoiceProductsState.filter(p => p.product_id === productId);
        console.log("selected product on click edit: ", selectedProduct[0].product.sellingPrice)
        setTva(selectedProduct[0].tva);
        setQty(selectedProduct[0].qty);
        setUnitPrice(selectedProduct[0].product.sellingPrice);
    }
    const deleteSingleProduct = (productId) => {
        for (let i = 0; i < invoiceProductsState.length; i++) {
            if (invoiceProductsState[i].product_id === productId) {
                invoiceProductsState.splice(i, 1);
                setInvoiceProductsToDelete([...invoiceProductsToDelete, productId])
            }
        }
        setInvoiceProductsState([...invoiceProductsState])
        const successMessage = 'le produit a été supprimer avec succés';
        toast.success(successMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }
    const getFaData = async () => {
        let fst = {};
        let snd = {};
        let res = {};
        const response2 = await jwtInterceoptor.get(baseURL + `/data/user/devis/byid/${id}`)
            .then((response) => {
                if (response.data.data.length === 0) {
                } else {
                    setInvoice(response.data.data);
                    setData(response.data.data[0]);
                    setInvoiceDataLoader(1);
                }
            }).catch((error) => console.log("error " + error))
    }

    const changeOfCanvasLayouts = () => {
        $("#all-fields-are-required").css('display', 'none');
        $('.select-article').css('display', 'block');
        $('.add-new-product-to-invoice-btn').css('display', 'inline');
        $('.edit-single-product').css('display', 'none');
        //reset value to default
        setSingleSelectedProduct([]);
        setQty(0);
        setUnitPrice(0);
        setTotalHt(0);
        setTva(0);
    }

    const emptyStates = () => {
        setQty(0);
        setUnitPrice(0);
        setTotalHt(0);
        setTva(0);
    }
    const checkIfProductAlreadyExist = (productId) => {
        for (let i = 0; i < invoiceProductsState.length; i++) {
            if (invoiceProductsState[i].product_id === productId) {
                console.log("exist")
                return true;
            }
        }
        console.log("! exist")
        return false;
    }
    const addNewProductToInvoice = async () => {
        emptyStates();
        if (selectedProduct.value === null || qty === 0) {
            const errorMessage = 'Tous les champs sont obligatoire !';
            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } else {
            if (checkIfProductAlreadyExist(singleSelectedProduct.value)) {
                const errorMessage = 'Le produit déja exist !';
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            } else {
                /**
                 * prepare product
                 * @type {{unitPrice: number, qty: number, name, totalTtc, totalHt, tva: number}}
                 */
                let product = {
                    'product_id': singleSelectedProduct.value,
                    'product': {
                        'name': singleSelectedProduct.label,
                        'sellingPrice': unitPrice,
                    },
                    'qty': qty,
                    'tva': tva,
                    'total_ht': leTotalHt.current.value,
                    'total_ttc': leTotalTTc.current.value
                };
                setInvoiceProductsState([...invoiceProductsState, product]);
                console.log("after click add new product, producs state is : ", [...invoiceProductsState, product])
            }
        }
    }

    const transformClientsArray = (clients) => {
        let array = [];
        for (let i = 0; i < clients.length; i++) {
            let obj = {value: clients[i].id, label: clients[i].name + ' ' + clients[i].lastName};
            array.push(obj);
        }
        return array;
    }

    const save = async () => {
        // check if all tab 1 inputs are !impty
        let isOkToEdit = true;
        isOkToEdit = !(client.length === 0 ||
            invoiceDueDate.length === 0 ||
            invoiceProductsState.length === 0 ||
            objet.length === 0
        );
        console.log("1st: ", isOkToEdit)

        //etat= payé
        if (selectedStatus === '2' && paymentType.length === 0) {
            isOkToEdit = false;
        }
        if (selectedStatus === '2' && paymentType.length !== 0) {
            if (banquePaymentOption.length === 0) {
                isOkToEdit = false;
            } else {
                if (banquePaymentOption === 'chéque' && chequeId.length === 0) {
                    isOkToEdit = false;
                }
            }
        }

        console.log("2nd: ", isOkToEdit)


        //etat = payé en partie
        if (selectedStatus === '3' && paymentType.length === 0) {
            isOkToEdit = false;
        }
        if (selectedStatus === '3' && paymentType.length !== 0) {
            if (banquePaymentOption.length === 0) {
                isOkToEdit = false;
            } else {
                if (banquePaymentOption === 'chéque' && chequeId.length === 0) {
                    isOkToEdit = false;
                }
            }
        }
        console.log("3th: ", isOkToEdit)

        if (selectedStatus === '3' && paymentType.length !== 0 && payedAmount === 0) {
            isOkToEdit = false;
        }
        console.log("4th: ", isOkToEdit)

        // console.log("selectedStatus !== '0': ", client)
        // console.log("selectedStatus !== '0': ", client[0].value)
        // isOkToEdit=false;
        if (isOkToEdit) {
            let preparedProducts = [];
            let statusIsChanged = false;
            for (let i = 0; i < invoiceProductsState.length; i++) {
                let obj = {
                    product_id: invoiceProductsState[i].product_id,
                    price_unit_ht: invoiceProductsState[i].product.sellingPrice,
                    qty: invoiceProductsState[i].qty,
                    total_ht: invoiceProductsState[i].total_ht,
                    total_ttc: invoiceProductsState[i].total_ttc,
                    tva: invoiceProductsState[i].tva,
                    reference: Math.random().toString(36).substring(2, 7)
                }
                preparedProducts.push(obj)
            }
            /**
             * preparedProducts = [
             *     {
             *         "product_id": 96,
             *         "price_unit_ht": 1250,
             *         "qty": 2,
             *         "total_ht": 2500,
             *         "total_ttc": 3000,
             *         "tva": 20
             *     },
             *     {
             *         "product_id": 97,
             *         "price_unit_ht": 100,
             *         "qty": "1",
             *         "total_ht": "100",
             *         "total_ttc": "110",
             *         "tva": 10
             *     }
             * ]
             */
            statusIsChanged = !(selectedStatus.length === 0);

            const newStatusHistory = {
                statusIsChanged: statusIsChanged,
                status_id: selectedStatus,
                payment_account_id: paymentType,
                banquePaymentOption: banquePaymentOption,
                chequeId: chequeId,
                payed_amount: payedAmount
            };

            let clientID = 0;

            const prepareObject = {
                invoice_id: id,
                client_id: client.value,
                total_ht: summaryTotatlHt,
                total_ttc: summaryTotatlTtc,
                total_tva: summaryTotalTva,
                title: objet,
                due_date: invoiceDueDate,
                products: preparedProducts,
                newStatusHistory: newStatusHistory,
                invoiceProductsToDelete: invoiceProductsToDelete
            };

            const response = await jwtInterceoptor.post(baseURL + `/data/user/facture_vente/edit`, prepareObject)
                .then((response) => {
                    Swal.fire(
                        'La facture de vente est modifier avec succés',
                        '',
                        'success'
                    );
                    console.log("************* after save edit, ", response.data.data)
                    setReloadState(1);
                }).catch((error) => console.log("error " + error))

        } else {
            const errorMessage = 'Merci de remplir tout les champs obligatoire !';
            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }

    }
    return (
        <>
            <ToastContainer/>
            <div className="container-fluid">
                <div className="row" style={{zIndex: 1}}>
                    <div className="col-lg-12">
                        <div class="page-header">
                            <h1 class="page-title">Detail du devis</h1>
                            <div>
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="javascript:void(0)">list des devis</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">details</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-8 col-md-12 card">
                        <div className="card-body" style={{ overflowX: "auto"}}>
                            <div class="col-xl-12">
                                <div class="panel panel-primary">

                                    <div class="panel-body tabs-menu-body">
                                        <div class="tab-content">
                                            <div class="tab-pane active">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <label htmlFor="exampleInputEmail1" className="">Devis
                                                            no:</label>
                                                        <input type={"text"} disabled={true} className="form-control"
                                                               value={isNumeric(invoiceNumber) ? `Devis-${formatNumber(invoiceNumber)}` : invoiceNumber}/>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="exampleInputEmail1"
                                                                   className="">Objet</label>
                                                            <input type="text" placeholder="objet"
                                                                   className={`form-control `}
                                                                   onChange={(e) => setObjet(e.target.value)}
                                                                   value={objet} disabled={true}/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <br/>
                                                <br/>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="exampleInputEmail1" className="">Nom du
                                                                client</label>
                                                            <Select
                                                                value={client}
                                                                onChange={(choice) => setClient(choice)}
                                                                isDisabled={true}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <br/>
                                                <div className="row">
                                                    <div className="col-md-6"></div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="exampleInputEmail1" className="">date de
                                                                devis</label>
                                                            <input type="text" placeholder="nom"
                                                                   className={`form-control `}
                                                                   onChange={(e) => setInvoiceCreatedAt(e.target.value)}
                                                                   value={invoiceCreatedAt} disabled={true}/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6"></div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="exampleInputEmail1" className="">date
                                                                d'échéance</label>
                                                            <input type="date" placeholder="nom"
                                                                   className={`form-control `}
                                                                   onChange={(e) => setInvoiceDueDate(e.target.value)}
                                                                   value={invoiceDueDate} disabled={true}/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <br/>
                                                <br/>
                                                <table className="table">
                                                    <thead>
                                                    <tr>
                                                        <th scope="col">DÉTAILS DE L’ARTICLE</th>
                                                        <th scope="col">QUANTITÉ</th>
                                                        <th scope="col">PU HT</th>
                                                        <th scope="col">TVA %</th>
                                                        <th scope="col">Total HT</th>
                                                        <th scope="col">Total TTC</th>
                                                    </tr>
                                                    </thead>

                                                    {
                                                        invoiceProductsState.map((product) => {
                                                            return (
                                                                <tr key={product.product_id}>
                                                                    <td>{product.product.name}</td>
                                                                    <td>{product.qty}</td>
                                                                    <td>{Number(product.total_ht).toFixed(2)/product.qty}</td>
                                                                    <td>{product.product.taxe_vente.rate + "%"}</td>
                                                                    <td>{Number(product.total_ht).toFixed(2)}</td>
                                                                    <td>{Number(product.total_ttc).toFixed(2)}</td>
                                                                </tr>
                                                            );
                                                        })
                                                    }

                                                </table>
                                                <div className="d-flex flex-row-reverse">
                                                    <div className="invoiceSummary">
                                                        <table>
                                                            <tr>
                                                                <td className={'invoiceSummary-base'}>Total HT :</td>
                                                                <td>{Number(summaryTotatlHt).toFixed(2)} {organisation?.currency?.code}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className={'invoiceSummary-base'}>Total TVA :</td>
                                                                <td>{Number(summaryTotalTva).toFixed(2)} {organisation?.currency?.code}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className={'invoiceSummary-base'}>Total TTC :</td>
                                                                <td>{Number(summaryTotatlTtc).toFixed(2)} {organisation?.currency?.code}</td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>


                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="col-xl-4 col-md-12">
                        <div class="tab-pane">
                            <div className="">
                                <div class="container">

                                    <ul class="notification">
                                        <li>
                                            <div class="notification-icon">
                                                <a href="javascript:void(0);"></a>
                                            </div>
                                            <div class="notification-body">
                                                <div class="media mt-0">
                                                    <div class="media-body ms-3 d-flex">
                                                        <div class="">
                                                            <p class="fs-18 text-dark fw-bold mb-0">
                                                                <span class="fe fe-clock"> </span>
                                                                {moment(invoiceStatus.created_at).format("DD/MM/YYYY")}
                                                            </p>
                                                            <p class="fs-18 text-dark fw-bold mb-0">Status
                                                                : {invoiceStatus}</p>                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="offcanvas offcanvas-bottom addProductCanvas" tabIndex="-1" id="offcanvasBottom"
                     aria-labelledby="offcanvasBottomLabel">
                    <div class="offcanvas-header">Renseigner le produit à ajouter.
                        <h5 class="offcanvas-title" id="offcanvasBottomLabel"></h5>
                        <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas"
                                aria-label="Close"><i class="fe fe-x fs-18"></i></button>
                    </div>
                    <div class="offcanvas-body">
                        <div id="all-fields-are-required">
                            <div class="alert alert-danger alert-dismissible fade show mb-0" role="alert">
                                <span class="alert-inner--icon"><i class="fe fe-slash"></i></span>
                                <span
                                    class="alert-inner--text"><strong>Attention!</strong> Tous les champs sont obligatoire !</span>
                            </div>
                            <br/>
                        </div>

                        <div id="warning-product-already-exists">
                            <div class="alert alert-danger alert-dismissible fade show mb-0" role="alert">
                                <span class="alert-inner--icon"><i class="fe fe-slash"></i></span>
                                <span
                                    class="alert-inner--text"><strong>Attention!</strong> Le produit déja exist !</span>
                            </div>
                            <br/>
                        </div>

                        <div id="qty-is-higher">
                            <div class="alert alert-danger alert-dismissible fade show mb-0" role="alert">
                                <span class="alert-inner--icon"><i class="fe fe-slash"></i></span>
                                <span class="alert-inner--text"><strong>Attention!</strong> L'article choisie est en rupture de stock</span>
                            </div>
                            <br/>
                        </div>

                    </div>
                </div>

            </div>
        </>
    )
        ;
}

export default DevisDetails;